import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import Swal from "sweetalert2";
import $ from "jquery";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import StatusFilter from "../../common/statusFilter";
import { SWAL_SETTINGS, showFilterlist, showFilterlistNew } from "../../../../utils/Constants";
import { TrimText, capitalizeFirstLetter, formateDateWithMonth, handleServerValidations, writeMyExcel } from "../../../../utils/commonfunction";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import * as usersService from "../../services/users.services";
import { useTranslation } from "react-i18next";
import CustomRangepicker from "../../common/rangepicker";
import { Placeholder, Tooltip, Whisper } from "rsuite";

const UsersList = () => {
  const params = useParams();
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [statsupdate, setStatusUpdate] = useState("false");
  const [datalength, setDataLength] = useState();
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({});
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [search, setSearch] = useState({});
  const [globalsearch, setGlobalSearch] = useState("");
  const breadcrumbs = [
    { title: t("admin.faq.link_dashboard"), url: "/admin/dashboard" },
    { title: "User Management", url: "" },
  ];
  const [resetdate, setResetDate] = useState(false);

  useEffect(() => {
    const getData = setTimeout(() => {
      if (search) {
        setLoader(true);
        const formData = new FormData();
        formData.append("page", params.pgno);
        formData.append("per_page", itemperpage);
        formData.append("sort", JSON.stringify(sorting));
        formData.append("search", JSON.stringify(search));
        formData.append("global_search", globalsearch);
        usersService
          .List(formData)
          .then((data) => {
            setDataLength(data.data.total_records);
            setList(data && data.data && data.data.list ? data.data.list : []);
            setLoader(false);
          })
          .catch((error) => {
            console.log("error ====> ", error);
          });
      }
    }, 300);

    return () => clearTimeout(getData);
  }, [location, statsupdate, sorting, search, globalsearch, params.pgno, globalsearch]);

  const viewfunction = (row) => {
    navigate(`/admin/user/view/${row._id}`);
  };

  const Editfunction = (row) => {
    navigate(`/admin/user/edit/${row._id}`);
  };

  const ChangeStatus = (data, Num) => {
    const formData = new FormData();
    formData.append("o_id", data);
    formData.append("status", Num);
    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("btn_yes"),
      cancelButtonText: t("btn_cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        usersService
          .Status(formData)
          .then((response) => {
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              setStatusUpdate(!statsupdate);
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("error===>");
          });
      }
    });
  };

  const handleSort = (e, column) => {
    setDefaultSorting(false);
    let sort = { order: 0, column: column };
    if (e.target.classList.contains("assc")) {
      sort.order = -1;
    } else {
      sort.order = 1;
    }
    setSorting(sort);
  };

  // search or filter function
  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    setSearch(sr);
  };
  // search or filer end

  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    prepareSearch();
    setSearch({});
    // reset customrangepicker & customstatusfilter state using jquery//
    setResetDate(!resetdate);
    $("#defaultstatus")[0].selectedIndex = 0;
  };

  function Deletefunction(data) {
    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      text: t("you_not_be_able_to_revert_this"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("Delete"),
      cancelButtonText: t("Cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        let ids = Array.isArray(data) ? data : [data];
        usersService
          .Delete(ids)
          .then((response) => {
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              setStatusUpdate(!statsupdate);
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("deleteError");
          });
      }
    });
  }

  const handleExportToExcel = () => {
    // Prepare the data for export
    const headers = ["Full Name", "Email", "Phone Number", "Address", "Created At", "Status"];

    const rows = list.map((row) => [
      row?.fullName ? capitalizeFirstLetter(row.fullName) : "N/A",
      row?.email ? row.email : "N/A",
      row?.phone_number ? row?.phone_number?.fullNumber : "N/A",
      row?.address ? capitalizeFirstLetter(row.address) : "N/A",
      row?.createdAt ? formateDateWithMonth(row.createdAt) : "N/A",
      row.status === 1 ? "Active" : "Inactive",
    ]);

    writeMyExcel([headers, ...rows], `${t("label_rating_report")}.xlsx`);
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {/* table section */}
      <div className="animation_fade">
        <div className="card custom-card overflow-hidden">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">User Management</h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input
                      type="search"
                      className="form-control"
                      value={globalsearch}
                      placeholder={t("Search")}
                      onChange={(e) => {
                        setGlobalSearch(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="me-3">
                  <CustomRangepicker
                    GetDateRange={(e) => {
                      prepareSearch("createdAt", e);
                    }}
                    resetdate={resetdate}
                  />
                </div>
                <div className="me-3">
                  <StatusFilter className="cp" data={showFilterlistNew} prepareSearch={prepareSearch} />
                </div>
                <button type="reset" value="Reset" onClick={resetFilter} className="btn btn-warning float-right mr-2 ripple">
                  {t("Reset filter")}
                </button>
                <button type="" value="" class="btn ripple btn-main-primary signbtn" onClick={() => handleExportToExcel()}>
                  Export Report
                </button>
              </div>
            </div>
            {
              loader?
              <Placeholder.Paragraph className="w-100" rowHeight={30} rowSpacing={5} active={true} rows={7}/>
              :
              <>
            <div className="table-responsive min-h-400">
              <table id="example-input" className="table table-bordered card-table border-top text-nowrap w-100">
                {/* <table id="example-input" className="table table-bordered border-t0 key-buttons text-nowrap w-100"> */}
                <thead>
                  <tr>
                    <th className="sr_head">{t("admin.faq.list_heading_sno")}</th>
                    <th>
                      <div className="sorting_column">
                        <span>Name</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="name" />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>Email</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="email" />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>Phone Number</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="phone_number" />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>Address</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="address" />
                      </div>
                    </th>
                    <th className="created_head">
                      <div className="sorting_column">
                        <span>{t("Created Date")}</span>
                        <Sorting sort={sorting} defaultSorting={defaultSorting} handleSort={handleSort} column="createdAt" />
                      </div>
                    </th>
                    <th className="status_head">{t("Status")}</th>
                    <th className="action_head">{t("Action")}</th>
                  </tr>
                </thead>
                <tbody>
                  {/* {loader ? (
                      <Placeholder.Paragraph className="w-100" rowHeight={30} rowSpacing={5} active={true} rows={7}/>
                  ) : (
                    <> */}
                      {list.length ? (
                        list.map((row, i) => {
                          return (
                            <tr key={i}>
                              <td>{row ? (page - 1) * itemperpage + i + 1 : null}</td>
                              <td>{capitalizeFirstLetter(row?.fullName) || "N/A"}</td>
                              <td>{row?.email || "N/A"}</td>
                              <td>{row?.phone_number ? row?.phone_number?.fullNumber : "N/A"}</td>
                              <td>{capitalizeFirstLetter(row?.address) || "N/A"}</td>
                              <td>{row?.createdAt ? formateDateWithMonth(row.createdAt) : "N/A"}</td>
                              <td>
                                <label className={"custom-switch cp" + (row.status !== 1 ? " e_none" : "")}>
                                  <input className="custom-switch-input cp" type="checkbox" checked={row?.status === 1} onChange={() => ChangeStatus(row?._id, row?.status === 1 ? 0 : 1)} />
                                  <span className="custom-switch-indicator cp"></span>
                                </label>
                              </td>
                              <td>
                                <div className="btn-toolbar table-actions" role="toolbar" aria-label="Toolbar with button groups">
                                  <div className="btn-group btn-group-sm" role="group" aria-label="Second group">
                                    <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: "bold" }}>View</Tooltip>}>
                                      <button
                                        type="button"
                                        className="btn view"
                                        onClick={() => {
                                          viewfunction(row);
                                        }}>
                                        <i className="ri-eye-fill"></i>
                                      </button>
                                    </Whisper>
                                    <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: "bold" }}>Edit</Tooltip>}>
                                      <button
                                        type="button"
                                        className="btn edit"
                                        onClick={() => {
                                          Editfunction(row);
                                        }}>
                                        <i className="ri-pencil-fill"></i>
                                      </button>
                                    </Whisper>
                                    <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: "bold" }}>Delete</Tooltip>}>
                                      <button
                                        type="button"
                                        className="btn delete"
                                        onClick={() => {
                                          Deletefunction(row?._id);
                                        }}>
                                        <i className="ri-delete-bin-6-fill"></i>
                                      </button>
                                    </Whisper>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={13} className="text-center">
                            {t("msg_no_records")}
                          </td>
                        </tr>
                      )}
                    {/* </>
                  )} */}
                </tbody>
              </table>
            </div>
            <div className="" id="example1_info" role="status" aria-live="polite">
              <b>
                {t("msg_total_records")} : {datalength ? datalength : "0"}
              </b>
            </div>
            {datalength && datalength > 0 ? (
              <CustomPagination datalength={datalength} itemperpage={itemperpage} setPage={setPage} currentPage={page} pageRoute={[{ name: "User", path: "/admin/user/list" }]} />
            ) : (
              ""
            )}
              </>
             }
          </div>
          <div></div>
        </div>
      </div>
    </>
  );
};

export default UsersList;
